// extracted by mini-css-extract-plugin
export default {"controls":"CommentEdit_controls__Rhlkf","field":"CommentEdit_field__JYrez"};